import './LandingPage.css';
import UnitLanding from './UnitLanding';
import SectorLanding from './SectorLanding';
import HierarchyDashboard from './HierarchyDashboard';

export default function LandingPage({ session, onLogout }) {
  const { user } = session;
  const roleId = Number(user?.role_id ?? NaN);

  if (roleId === 5) {
    return <UnitLanding session={session} onLogout={onLogout} />;
  }

  if (roleId >= 1 && roleId <= 4) {
    if (roleId === 4) {
      return <SectorLanding session={session} onLogout={onLogout} />;
    }

    return <HierarchyDashboard session={session} onLogout={onLogout} />;
  }

  return (
    <div className="landing-container">
      <header className="landing-header">
        <div>
          <h1 className="landing-title">Welcome, {user?.orgname || user?.login_name || 'User'}</h1>
          <p className="landing-subtitle">Dashboards are available for organisation roles with hierarchy access.</p>
        </div>
        <button type="button" className="landing-logout" onClick={onLogout}>
          Log out
        </button>
      </header>

      <section className="landing-content">
        <div className="panel warning">
          <p>
            Please sign in with a sector-level (role ID 4) or unit-level (role ID 5) account to access the sadaqa
            dashboards.
          </p>
        </div>
      </section>
    </div>
  );
}
